module.exports = __webpack_public_path__ + "img/ddos_bg.3619870b.jpg";